import React from 'react';
import { Entry, EntryFields } from 'contentful';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

// eslint-disable-next-line import/no-cycle
import { RICH_TEXT_RENDERER_OPTIONS } from 'src/constants/richTextRendererOptions';

type TextBlockEntryData = Entry<{
  name: string;
  body: EntryFields.RichText & {
    nodeType: BLOCKS.DOCUMENT;
  };
}>;

export type TextBlockGroupType = Entry<{
  name: string;
  linkedTextBlockEntries: TextBlockEntryData[];
}>;

const TextBlockGroup = ({
  data,
}: {
  data?: TextBlockGroupType;
}): JSX.Element => (
  <>
    {data?.fields?.linkedTextBlockEntries &&
      data?.fields?.linkedTextBlockEntries.map((textBlockEntry) =>
        documentToReactComponents(
          textBlockEntry?.fields?.body,
          RICH_TEXT_RENDERER_OPTIONS,
        ),
      )}
  </>
);

export default TextBlockGroup;
